export const BRAND = "VARSHA SUBLIMATION";
export const BRAND_SHORT = "Varsha Sublimation";
export const WHATSAPP_NUMBER = "919760877279";
export const TRACK_ORDER_URL = "https://www.icarry.in/pages/track.html";

export const ADMIN_PHONES = ["9760877279", "7300877279"];

export const isAdminPhone = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "").slice(-10);
  return ADMIN_PHONES.includes(digits);
};
export const CATEGORIES = [
  "All Products",
  "Heat Press Machines",
  "Inks, Papers & Parts",
  "T-Shirts & Apparel",
  "Mugs & Drinkware",
  "Frames, Clocks & Decor",
  "Keychains, Badges & Cards",
  "Lamps & Mirrors",
  "Cushions & Mouse Pads",
];
export const formatINR = (n) => "₹" + Math.round(Number(n) || 0).toLocaleString("en-IN");

export const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat",
  "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh",
  "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan",
  "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Andaman & Nicobar Islands", "Chandigarh", "Dadra & Nagar Haveli and Daman & Diu", "Delhi",
  "Jammu & Kashmir", "Ladakh", "Lakshadweep", "Puducherry",
];

export function resolveWhatsAppNumber(routes, state) {
  const match = routes.find((r) => (r.states || []).includes(state));
  const fallback = routes.find((r) => r.is_default) || routes[0];
  return (match || fallback)?.number || WHATSAPP_NUMBER;
}

export const priceOf = (product) => (product?.offer_price != null ? product.offer_price : product?.price || 0);
